module.exports = __webpack_public_path__ + "static/media/photos-group.3eb176cb.png";